var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8086 7.19121C15.9536 7.33627 15.9536 7.57137 15.8086 7.71643C15.6635 7.86149 15.4284 7.86149 15.2833 7.71643C15.1383 7.57137 15.1383 7.33627 15.2833 7.19121C15.4294 7.04615 15.6635 7.04615 15.8086 7.19121",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0765 12.2845L19.3861 10.9749C19.7812 10.5787 20.0033 10.0445 20.0033 9.48628V5.09946C20.0033 3.93797 19.0619 2.99658 17.8984 2.99658H13.5116C12.9544 2.99658 12.4192 3.21867 12.026 3.61284L3.6125 12.0263C2.79115 12.8477 2.79115 14.1792 3.6125 15.0006L7.99932 19.3874C8.82067 20.2088 10.1522 20.2088 10.9736 19.3874L12.2841 18.0769",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2526 15.627L16.0637 17.8159L14.7511 16.5023",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 21.0042C14.0158 21.0042 12 18.9884 12 16.5024C12 14.0674 14.0709 11.9985 16.5049 12.0005C18.9899 12.0025 21.0037 14.0173 21.0037 16.5024C21.0037 18.9884 18.9889 21.0042 16.5019 21.0042",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/CampaignIcon.5bc0600875adf2cf9dafc9a64d6c397a.svg";
export { ForwardRef as ReactComponent };